import * as React from 'react';

import {RouteComponentProps} from 'react-router';
import LessonApi from '../modules/lessons/api/LessonApi';
import Lesson from '../modules/lessons/domain/aggregates/lesson/Lesson';
import Page from './Page';
import LessonResultApi from '../modules/lessons/api/LessonResultApi';
import ExerciseApi from '../modules/lessons/api/ExerciseApi';
import { Button, Table, Icon, Grid, Header } from 'semantic-ui-react';
import Exercise from '../modules/lessons/domain/aggregates/exercise/Exercise';
import Course from '../modules/lessons/domain/aggregates/course/Course';
import CourseApi from '../modules/lessons/api/CourseApi';
import LessonResult from '../modules/lessons/domain/aggregates/lessonResult/LessonResult';
import Registry from '../global/Registry';
import ReviewReminder from './components/lesson/ReviewReminder';

interface Props {
	id?: string;
}

interface State {
	courses: Course[];
	lessons: Lesson[];
	exercisesToReview: Exercise[];
	lessonResults: LessonResult[];
	course?: Course;
}

export default class DashboardPage extends Page<RouteComponentProps<Props>, State> {

	public constructor (props: RouteComponentProps<Props>) {
		super(props);

		this.state = { lessons: [], courses: [], exercisesToReview: [], lessonResults: []};
	}

	async componentWillMount () {
		if (!Registry.getInstance().me.isOrganizationAccount()) {
			Page.navigate('/');
		}

		const [courses, lessons, exercisesToReview, lessonResults] = await Promise.all([
			CourseApi.getInstance().getAll(),
			LessonApi.getInstance().getAll(),
			ExerciseApi.getInstance().getAllToRepeatByUserId(Registry.getInstance().me.getId()),
			LessonResultApi.getInstance().getAllByUserId(Registry.getInstance().me.getId())
		]);

		const course = Registry.getInstance().courseRepository.getOneOrUndefinedByIdValue(this.props.match.params.id);

		this.setState({courses, lessons, exercisesToReview, lessonResults, course});
	}

	async componentWillReceiveProps (props: RouteComponentProps<Props>) {
		const course = Registry.getInstance().courseRepository.getOneOrUndefinedByIdValue(props.match.params.id);

		this.setState({course});
	}

	protected isLoading (): any {
		return this.state.courses.length === 0;
	}

	protected renderTitle (): string {
		return 'Brain Brooder - Digital Math & Science Education';
	}

	protected renderDescription (): string {
		return 'Learn Math and Science deeply, by taking small but dense lessons that are followed by intelligently repeated exercises, such that you never forget.';
	}

	protected renderContent () {
		const courses = this.state.courses;

		const organizationCourses = courses.filter(course => course.getVisibility().isOrganization());
		const privateCourses = courses.filter(course => course.getVisibility().isPrivate());

		const path = this.props.match.path;

		const me = Registry.getInstance().me;
		const organization = Registry.getInstance().organizationRepository.getById(me.getOrganizationId());

		return (
			<div className='lesson home'>
				<div style={{textAlign: 'center'}}>
					<Header className={'main'} inverted as='h1' content={organization.getName()} subheader='Teaching and learning center' style={{margin: '36px'}} />

					<ReviewReminder />

					<div className={'tabs2'} style={{marginTop: '48px'}}>

						<input id='tab1' type='radio' name='tabs' checked={path === '/dashboard'} readOnly />
						<label id='label1' onClick={() => Page.navigate('/dashboard')}><Icon name={'users'} /> <span>{organization.getName()} courses</span></label>

						<input id='tab2' type='radio' name='tabs' readOnly checked={path === '/dashboard/my-courses'} />
						<label id='label2' onClick={() => Page.navigate('/dashboard/my-courses')}><Icon name={'user'} /> <span>Personal courses</span></label>

						<section id='content1'>

							{organizationCourses.length > 0 ? (
								<div>
									<CoursesTable title='Courses' courses={organizationCourses} />

									<Button inverted color={'grey'} fluid onClick={() => Page.navigate('/course/new/organization')} style={{marginTop: '36px'}}><Icon name={'plus'} />  Create a new course</Button>
								</div>
							) : (
								<div>
									<div style={{margin: '48px 0'}}>
										<h2>You haven't created any personal courses yet.</h2>
									</div>
									<p><Button inverted size={'big'} color={'green'} onClick={() => Page.navigate('/course/new')}><Icon name={'plus'} />  Create your first course</Button></p>
								</div>
							)}

							<div style={{width: '100%', textAlign: 'center', marginTop: '320px'}}><img style={{width: '307px'}} src='/images/contact.png' /></div>
						</section>

						<section id='content2'>
							{privateCourses.length > 0 ? (
								<div>
									<CoursesTable title='Courses' courses={privateCourses} />

									<Button inverted color={'grey'} fluid onClick={() => Page.navigate('/course/new')} style={{marginTop: '36px'}}><Icon name={'plus'} />  Create a new course</Button>
								</div>
							) : (
								<div>
									<div style={{margin: '48px 0'}}>
										<h2>You haven't created any personal courses yet.</h2>
									</div>
									<p><Button inverted size={'big'} color={'green'} onClick={() => Page.navigate('/course/new')}><Icon name={'plus'} />  Create your first course</Button></p>
								</div>
							)}
						</section>
					</div>
				</div>
			</div>
		);
	}
}

const CoursesTable: React.SFC<{title: string, courses: Course[]}> = ({title, courses}) => {

	return (
		<Table inverted selectable unstackable>
			<Table.Header>
				<Table.Row>
					<Table.HeaderCell>{title}</Table.HeaderCell>
				</Table.Row>
			</Table.Header>
			<Table.Body>
				{courses.sort((a, b) => a.getName().localeCompare(b.getName())).map((course, key) => <Table.Row key={key} onClick={() => Page.navigate(course.getSlug())}><Table.Cell><a onClick={(event) => event.preventDefault()} style={{color: 'inherit'}} href={course.getSlug()}>{course.getName()}</a></Table.Cell></Table.Row>)}
			</Table.Body>
		</Table>
	);
};


// WEBPACK FOOTER //
// ./code/project/pages/DashboardPage.tsx